// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroTiles_wrapper__loP5i","main":"HeroTiles_main__PYDbD","item":"HeroTiles_item__Mmt7q"};